import api from '@/modules/api.service';
import { Endpoints } from '@/shared/constants/endpoints';
import type {
  AuditoriaRateLimitStatsDto,
  FindAuditoriaRateLimitStatsDto,
} from './auditoria-rate-limit.types';

export async function GetAuditoriaRateLimitStats(
  filters: FindAuditoriaRateLimitStatsDto,
): Promise<AuditoriaRateLimitStatsDto> {
  const response = await api.get<AuditoriaRateLimitStatsDto>(
    `${Endpoints.AUDITORIA_RATE_LIMIT}/stats`,
    { params: filters },
  );
  return response.data;
}
